import Api from "./Api";
import { debugLog } from "../../utils/debug";

export async function saveSongBookPreferences(ids) {
    return Api.post(`/user/` + JSON.parse(sessionStorage.getItem("customer")).user.id + `/preferences/song-book`, ids)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            // Something went wrong
            if (error.response.data) {
                debugLog("Known error: " + error.response.data);
                this.setState({
                    apiError: "Unknown error when saving song book preferences",
                    formSubmitted: false
                })
            } else {
                debugLog("Got the following error when trying to save song book preferences: " + error.message);
                this.setState({
                    generalApiError: "Something went wrong, if this persists please contact us",
                    formSubmitted: false
                })
            }
            return null;
        })
}

export function getSongBookPreferences() {
    const customer = sessionStorage.getItem("customer");
    if (!customer) {
        debugLog("UserPreferencesHelpers - no customer found in session, returning empty array for song book preferences");
        return Promise.resolve([]); // Return resolved Promise with empty array
    }

    let customerId;
    try {
        customerId = JSON.parse(customer)?.user?.id;
    } catch (error) {
        debugLog("UserPreferencesHelpers - error parsing customer from session for song book preferences: " + error.message);
        return Promise.resolve([]); // Return resolved Promise with empty array on parse error
    }

    return Api.get("/user/" + customerId + "/preferences/song-book")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            debugLog("UserPreferencesHelpers - an error when trying to get song book preferences: " + error.message);
            return [];
        });
}

export async function saveThemePreferences(ids) {
    return Api.post(`/user/` + JSON.parse(sessionStorage.getItem("customer")).user.id + `/preferences/theme`, ids)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            // Something went wrong
            if (error.response.data) {
                debugLog("Known error: " + error.response.data);
                this.setState({
                    apiError: "Unknown error when saving theme preferences",
                    formSubmitted: false
                })
            } else {
                debugLog("Got the following error when trying to save theme preferences: " + error.message);
                this.setState({
                    generalApiError: "Something went wrong, if this persists please contact us",
                    formSubmitted: false
                })
            }
            return null;
        })
}

export function getThemePreferences() {
    debugLog("UserPreferencesHelpers - requesting themes from server");

    const customer = sessionStorage.getItem("customer");
    if (!customer) {
        debugLog("UserPreferencesHelpers - no customer found in session, returning empty array");
        return Promise.resolve([]); // Return resolved Promise with empty array
    }

    let customerId;
    try {
        customerId = JSON.parse(customer)?.user?.id;
    } catch (error) {
        debugLog("UserPreferencesHelpers - error parsing customer from session: " + error.message);
        return Promise.resolve([]); // Return resolved Promise with empty array on parse error
    }

    return Api.get("/user/" + customerId + "/preferences/theme")
        .then(res => {
            debugLog("UserPreferencesHelpers - got the following themes from server: " + JSON.stringify(res.data));
            return res.data;
        })
        .catch(error => {
            debugLog("UserPreferencesHelpers - an error when trying to get theme preferences: " + error.message);
            return [];
        });
}
